module.exports = __webpack_public_path__ + "static/media/Desktop_Summary_12.40f25d13.png";